import Transition from 'react-transition-group/Transition';
import './Collapse.scss';

export const DURATION = 500;
const defaultStyle = {
    transition: `all ${DURATION}ms ease`,
    opacity: 0,
    maxHeight: 0,
    overflowY: 'auto',
};
const transitionStyles = {
    entering: {opacity: 0, maxHeight: 0},
    entered: {opacity: 1, maxHeight: '63rem'},
    exited: {display: 'none'},
};

// add header and footer
const Collapse = ({
                      renderHeader, renderContent, expanded, onClick, onClose, closePosition, id,
                  }) => {
    const header = renderHeader();
    return (
        <div id={id}
             className={`collapse-container ${expanded ? 'collapse-container--expanded' : 'collapse-container--collapsed'}`}>
            {header && (
                <div className="collapse-container__header" onClick={onClick} role="button" tabIndex={0}>
                    {header}
                </div>
            )}
            <Transition in={expanded} timeout={DURATION}>
                {state => (
                    <div
                        style={{
                            ...defaultStyle,
                            ...transitionStyles[state],
                            marginBottom: expanded && closePosition === 'bottom' ? '6.5rem' : '0',
                            height: 'auto',
                        }}
                        className="collapse-container__content"
                    >
                        {renderContent()}
                        <div
                            className={`close-button ${closePosition === 'top' ? 'close-button--top' : 'close-button--bottom'}`}
                            onClick={onClose}
                            role="button"
                            tabIndex={0}
                        />
                    </div>
                )}
            </Transition>
        </div>
    );
};

export default Collapse;
